import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createNewAsset } from '../../../../actions/inventory';
import moment from 'moment';
import { actualValueForDropdown } from '../../../../utils/common';
import { useForm } from 'react-hook-form';
import Form from '../../../../common/Form';
import Customer from '../../../../components/Inputs/Customer';
import Warehouse from '../../../../components/Inputs/Warehouse';
import Enduser from '../../../../components/Inputs/Enduser';
import AssetType from '../../../../components/Inputs/AssetType';
import DatePicker from '../../../../common/Form/DatePicker';
import Select from '../../../../common/Form/Select';
import Checkbox from '../../../../common/Form/Checkbox';
import Input from '../../../../common/Form/Input';
import RenderContact from '../../../../components/Inputs/Contact';

export const warrantyType = [
    { key: 1, value: 'MANUFACTURING', label: 'Manufacturing' },
    { key: 2, value: 'INSTALLATION', label: 'Installation' },
    { key: 3, value: 'BILLING', label: 'Billing' },
];

export const workingCondition = [
    { key: 1, value: 'NEW', label: 'New' },
    { key: 2, value: 'REFURBISHED', label: 'Refurbished' },
    { key: 3, value: 'FAULTY', label: 'Faulty' },
];

export default function SpareAssetFrom(props) {
    const formName = 'spareAssetForm';
    const dispatch = useDispatch();

    const { closeForm } = props;
    const warehouseId = props?.selectedWarehouseId;

    const defaultValues = {};

    const { formButtonLoading } = useSelector((state) => state.loading);

    const isToShowCustomerDropdown = true;

    const submit = (formValues) => {
        let owner;
        let owner_id
        if (actualValueForDropdown(formValues?.contact) === 'add-new-contact') {
            owner = {
                name: formValues[`contact:name`],
                email: formValues[`contact:email`],
                mobile: formValues[`contact:mobile`]
            }
        } else if (formValues?.contact) {
            owner_id = formValues.contact.id;
        }

        const payload = {
            serial_number: formValues.serial_number,
            asset_type_id: actualValueForDropdown(formValues.asset_type_id),
            location_id: actualValueForDropdown(formValues.warehouse) || warehouseId,
            org_id: actualValueForDropdown(formValues.customer),
            make: formValues.make,
            owner,
            owner_id,
            added_on: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            model: formValues.model,
            partcode: formValues.partcode,
            external_id: formValues.external_id,
            status: "AVAILABLE",
            working_condition: actualValueForDropdown(formValues.working_condition),
            is_temporary: false,
            is_spare: true,
            warranty_type: actualValueForDropdown(formValues.warranty_type),
            warranty_start_date: formValues.warranty_start_date,
            warranty_end_date: formValues.warranty_end_date,
        };
        dispatch(createNewAsset({
            payload, formName, onSuccess: () => {
                closeForm();
                reset();
            }
        }));
    };


    const methods = useForm({ defaultValues, mode: 'all' });
    const { reset, watch } = methods;

    const hasWarranty = methods.watch('hasWarranty');
    const selectedCustomer = methods.watch('customer');


    return (
        <Form
            className='w-full'
            onSubmit={submit}
            onCancel={closeForm}
            submitButtonText={'Create'}
            showSubmit
            submitContainerClassName='flex gap-2 py-4 px-4'
            isLoading={formButtonLoading[formName]}
            methods={methods}
        >
            <div className='grid grid-cols-2 rows-fr grid-flow-row-dense px-3'>
                {isToShowCustomerDropdown && (
                    <Customer name='customer' label='Customer' />
                )}
                <Warehouse name='warehouse' label='Warehouse' org_id={actualValueForDropdown(selectedCustomer)} prefill={warehouseId ? [warehouseId] : []} />
                <AssetType name='asset_type_id' label='Asset Type' org_id={actualValueForDropdown(selectedCustomer)} />
                <Enduser name='enduser' label='End User' org_id={actualValueForDropdown(selectedCustomer)} />
                <Input label='Serial Number' name='serial_number' type={'text'} />
                <Input label='Make' name='make' type={'text'} />
                <Input label='Model' name='model' type={'text'} />
                <Input label='Partcode' name='partcode' type={'text'} />
                <Input label='External Id' type={'text'} name='external_id' />
                <RenderContact name={'contact'} label={'Contact Name'} org_id={actualValueForDropdown(selectedCustomer)} />
                <Select label='Working Condition' name='working_condition' options={workingCondition} />
                <DatePicker label='Added On' name='added_on' dateFormat='dd-MM-yyyy' />


                <br />
                <div className='px-1'>
                    <Checkbox label='Do you have Warranty Details' name='hasWarranty' />
                </div>
                {watch('hasWarranty') && (
                    <>
                        <div className='w-full'>
                            <Select label='Type' type={'dropdown'} name='warranty_type' options={warrantyType} shouldUnregister />
                        </div>

                        <div className='grid grid-cols-2 rows-fr grid-flow-row-dense'>
                            <DatePicker label='Warranty Start Date' name='warranty_start_date' dateFormat='dd-MM-yyyy' shouldUnregister />
                            <DatePicker label='Warranty End Date' name='warranty_end_date' dateFormat='dd-MM-yyyy' shouldUnregister />
                        </div>
                    </>
                )}

            </div>
        </Form>
    );
}
